import { LifeBuoy } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

/**
 * SandboxBanner — sticky strip rendered at the top of every admin page when
 * the logged-in user has the `demo_admin` role. Makes it visually obvious
 * that no changes will be persisted.
 */
export default function SandboxBanner() {
  const { isDemoAdmin, user } = useAuth();
  if (!isDemoAdmin) return null;
  return (
    <div
      className="rounded-md border-2 border-amber-500/60 bg-amber-500/10 px-3 py-2 mb-3 flex items-center gap-2.5"
      data-testid="sandbox-banner"
    >
      <LifeBuoy className="w-4 h-4 text-amber-400 shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="text-sm font-semibold text-amber-300">Sandbox mode</div>
        <div className="text-[11px] text-amber-200/80 leading-snug">
          You're signed in as <span className="font-mono">{user?.email}</span> with the demo-admin role. You can navigate every admin screen and click every button — nothing you save will actually be persisted.
        </div>
      </div>
    </div>
  );
}
